import * as z$1 from "zod/v4";
//#region src/schemas/daemon/execution-identity.ts
const RUNTIME_EXECUTION_IDENTITY_MODEL_VERSION = "openmeld.runtime.execution_identity.v1";
const boundedIdentifierSchema = z$1.string().trim().min(1).max(512);
const runtimeExecutionAuthorityOpenMeldServiceRuntimeIdSchema = z$1.strictObject({
	source: z$1.literal("runtime_registry_authority"),
	value: boundedIdentifierSchema
});
const runtimeExecutionIdentityCoreSchema = z$1.strictObject({
	modelVersion: z$1.literal(RUNTIME_EXECUTION_IDENTITY_MODEL_VERSION),
	spaceId: boundedIdentifierSchema,
	dispatchId: boundedIdentifierSchema,
	targetProfileId: boundedIdentifierSchema,
	openMeldServiceRuntimeId: runtimeExecutionAuthorityOpenMeldServiceRuntimeIdSchema,
	bindingId: boundedIdentifierSchema,
	agentControllerRef: boundedIdentifierSchema
});
const runtimeTransportDeliveryExecutionIdentitySchema = z$1.strictObject({
	authority: z$1.literal("core_runtime_registry_binding_route"),
	core: runtimeExecutionIdentityCoreSchema
});
const runtimeTransportRuntimeEvidenceIdentityEchoSchema = z$1.strictObject({
	echoSource: z$1.literal("daemon_delivery_context"),
	core: runtimeExecutionIdentityCoreSchema
});
const runtimeTransportResultIdentityEchoSchema = z$1.strictObject({
	echoSource: z$1.literal("daemon_delivery_context"),
	core: runtimeExecutionIdentityCoreSchema
});
const spaceTraceExecutionIdentityProjectionSchema = z$1.strictObject({
	factSource: z$1.enum([
		"runtime_coordinator_projection",
		"dispatch_attempt_execution_identity",
		"dispatch_claim_lease_legacy"
	]),
	authority: z$1.enum(["authoritative", "legacy_projection"]),
	core: runtimeExecutionIdentityCoreSchema
});
//#endregion
export { RUNTIME_EXECUTION_IDENTITY_MODEL_VERSION, runtimeExecutionAuthorityOpenMeldServiceRuntimeIdSchema, runtimeExecutionIdentityCoreSchema, runtimeTransportDeliveryExecutionIdentitySchema, runtimeTransportResultIdentityEchoSchema, runtimeTransportRuntimeEvidenceIdentityEchoSchema, spaceTraceExecutionIdentityProjectionSchema };

//# sourceMappingURL=execution-identity.js.map